import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }

  public convertDate(date:any){

      date = date.split('/')
      return date[2]+'-'+date[1]+'-'+date[0]
    
  }

  public toTop(): void{

    window.scrollTo({

      top: 0,
      behavior: 'smooth'

    });

  }

  public maskPhone(phone: any){

    phone=phone.replace(/\D/g,"")                 
    phone=phone.replace(/^(\d\d)(\d)/g,"($1) $2") 
    phone=phone.replace(/(\d{5})(\d)/,"$1-$2")  
    phone = (phone.substring(0,7) + '*' + phone.substring(7+1))
    phone = (phone.substring(0,8) + '*' + phone.substring(8+1))
    phone = (phone.substring(0,9) + '*' + phone.substring(9+1))
    phone = (phone.substring(0,11) + '*' + phone.substring(11+1))
    phone = (phone.substring(0,12) + '*' + phone.substring(12+1))

    return phone

  }

}
